module.exports = __webpack_public_path__ + "static/media/MbBanescoLogo.cb675618.svg";